import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { AppProviders } from "./providers"
import { AppRouter } from "./router"
import "@/styles/globals.css"

const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("#root missing from index.html")

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
)
